import { render, staticRenderFns } from "./technocracyAdd.vue?vue&type=template&id=42e1bcc0"
import script from "./technocracyAdd.vue?vue&type=script&lang=js"
export * from "./technocracyAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e1bcc0')) {
      api.createRecord('42e1bcc0', component.options)
    } else {
      api.reload('42e1bcc0', component.options)
    }
    module.hot.accept("./technocracyAdd.vue?vue&type=template&id=42e1bcc0", function () {
      api.rerender('42e1bcc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/technocracy/technocracyAdd.vue"
export default component.exports